import { useEffect, useState } from "react";
import { apiRequest } from "./apiRequest";
import { showToast } from "./toastOptions";

let cachedUser = null;
let userPromise = null;

function fetchUserOnce() {
  if (cachedUser) return Promise.resolve(cachedUser);
  if (!userPromise) {
    userPromise = apiRequest(`${process.env.REACT_APP_API_BASE_URL}/get-user-info/`, {
      method: "GET",
      suppressErrorToast: true,
    })
      .then((json) => {
        cachedUser = json?.data || null;
        return cachedUser;
      })
      .catch((e) => {
        userPromise = null;
        throw e;
      });
  }
  return userPromise;
}

export function clearUserSessionCache() {
  cachedUser = null;
  userPromise = null;
}

/**
 * Fetches the current user session from the backend.
 * Returns { user, loading, error }.
 */
export function useUserSession() {
  const [user, setUser] = useState(cachedUser);
  const [loading, setLoading] = useState(!cachedUser);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedUser) {
      setUser(cachedUser);
      setLoading(false);
      return;
    }
    let mounted = true;
    fetchUserOnce()
      .then((data) => {
        if (mounted) {
          setUser(data);
          setError(null);
        }
      })
      .catch((e) => {
        if (mounted) {
          setError(e.message || "Failed to load user session.");
        }
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (error) {
      showToast("error", error);
    }
  }, [error]);

  return { user, loading, error };
}
